import {
  css3,
  framerMotion,
  git,
  github,
  html5,
  javascript,
  mongodb,
  nextjs,
  nodeJs,
  express,
  react,
  redux,
  tailwind,
  typescript,
  wordpress,
  figma,
} from '../assets';

export const skillSet = [
  {
    name: 'JavaScript',
    path: javascript,
  },
  {
    name: 'React',
    path: react,
  },
  {
    name: 'Redux',
    path: redux,
  },
  {
    name: 'NextJS',
    path: nextjs,
  },
  {
    name: 'TypeScript',
    path: typescript,
  },
  {
    name: 'HTML5',
    path: html5,
  },
  {
    name: 'CSS3',
    path: css3,
  },
  {
    name: 'Tailwind',
    path: tailwind,
  },
  {
    name: 'WordPress',
    path: wordpress,
  },
  {
    name: 'Figma',
    path: figma,
  },
  {
    name: 'FramerMotion',
    path: framerMotion,
  },
  {
    name: 'Git',
    path: git,
  },
  {
    name: 'GitHub',
    path: github,
  },
  {
    name: 'NodeJS',
    path: nodeJs,
  },
  {
    name: 'ExpressJS',
    path: express,
  },
  {
    name: 'MongoDB',
    path: mongodb,
  },
];
